import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'
import type { Goal } from '../../types/goal'

interface DayGoalsListProps {
  goals: Goal[]
  onEdit?: (goal: Goal) => void
}

export function DayGoalsList({ goals, onEdit }: DayGoalsListProps) {
  const { t } = useTranslation()

  if (goals.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {goals.map((goal) => (
        <Badge
          key={goal.id}
          variant="outline"
          className="cursor-pointer border-orange-400 text-orange-400 hover:bg-orange-400/10 truncate max-w-[200px]"
          onClick={() => onEdit?.(goal)}
          title={goal.body}
        >
          🎯 {goal.body}
        </Badge>
      ))}
      {goals.length === 0 && (
        <span className="text-xs text-muted-foreground">{t('trainingDiary.goals.empty')}</span>
      )}
    </div>
  )
}
